/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, {useEffect, useState} from 'react';
import {NavLink, useNavigate, useLocation, Location} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {IMenuItem} from '@app/modules/main/menu-sidebar/MenuSidebar';
import {FaUsers} from 'react-icons/fa';
import {BsCardChecklist} from 'react-icons/bs';
import {FaCalendarAlt, FaFileAlt, FaTasks} from 'react-icons/fa';
import {FaThList} from 'react-icons/fa';
import {MdGroupWork} from 'react-icons/md';
import {BsBugFill} from 'react-icons/bs';

const MenuIcon = ({itemName}) => {
  if (itemName === 'Dashboard') {
    return (
      <>
        <i className="nav-icon fas fa-tachometer-alt" />
        <p>{itemName}</p>
      </>
    );
  }
  if (itemName === 'All Dailies') {
    return (
      <>
        <FaThList className="iconclass" />
        <p>{itemName}</p>
      </>
    );
  }
  if (itemName === 'Dailies') {
    return (
      <>
        <FaThList className="iconclass" />
        <p>{itemName}</p>
      </>
    );
  }
  if (itemName === 'All Leaves') {
    return (
      <>
        <FaCalendarAlt className="iconclass" />
        <p>{itemName}</p>
      </>
    );
  }

  if (itemName === 'Leaves') {
    return (
      <>
        <FaCalendarAlt className="iconclass" />
        <p>{itemName}</p>
      </>
    );
  }
  if (itemName === 'Clients') {
    return (
      <>
        <MdGroupWork className="iconclass" />
        <p>{itemName}</p>
      </>
    );
  }
  if (itemName === 'Cases') {
    return (
      <>
        <BsBugFill className="iconclass" />
        <p>{itemName}</p>
      </>
    );
  }

  if (itemName === "Today's Case") {
    return (
      <>
        <BsBugFill className="iconclass" />
        <p>{itemName}</p>
      </>
    );
  }
  if (itemName === 'Projects') {
    return (
      <>
        <BsCardChecklist className="iconclass" />
        <p>{itemName}</p>
      </>
    );
  }
  if (itemName === 'Users') {
    return (
      <>
        <FaUsers className="iconclassAllDailies" />
        <p>{itemName}</p>
      </>
    );
  }

  if (itemName === 'All Users') {
    return (
      <>
        <FaUsers className="iconclassAllDailies" />
        <p>{itemName}</p>
      </>
    );
  }

  if (itemName === 'All Projects') {
    return (
      <>
        <BsCardChecklist className="iconclassAllDailies" />
        <p>{itemName}</p>
      </>
    );
  }
  if (itemName === "Todo's") {
    return (
      <>
        <FaFileAlt style={{marginRight: '8px'}} />
        <p>{itemName}</p>
      </>
    );
  }
  if (itemName === 'Tasks') {
    return (
      <>
        <FaTasks style={{marginRight: '8px'}} />
        <p>{itemName}</p>
      </>
    );
  }
};
const MenuItem = ({menuItem}: {menuItem: IMenuItem}) => {
  const [t] = useTranslation();
  const [isMenuExtended, setIsMenuExtended] = useState(false);
  const [isExpandable, setIsExpandable] = useState(false);
  const [isMainActive, setIsMainActive] = useState(false);
  const [isOneOfChildrenActive, setIsOneOfChildrenActive] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuExtended(!isMenuExtended);
  };

  const handleMainMenuAction = () => {
    if (isExpandable) {
      toggleMenu();
      return;
    }
    navigate(menuItem.path ? menuItem.path : '/');
  };

  const calculateIsActive = (url: Location) => {
    setIsMainActive(false);
    setIsOneOfChildrenActive(false);
    if (isExpandable && menuItem && menuItem.children) {
      menuItem.children.forEach((item) => {
        if (item.path === url.pathname) {
          setIsOneOfChildrenActive(true);
          setIsMenuExtended(true);
        }
      });
    } else if (menuItem.path === url.pathname) {
      setIsMainActive(true);
    }
  };

  useEffect(() => {
    if (location) {
      calculateIsActive(location);
    }
  }, [location, isExpandable, menuItem]);

  useEffect(() => {
    if (!isMainActive && !isOneOfChildrenActive) {
      setIsMenuExtended(false);
    }
  }, [isMainActive, isOneOfChildrenActive]);

  useEffect(() => {
    setIsExpandable(
      Boolean(menuItem && menuItem.children && menuItem.children.length > 0)
    );
  }, [menuItem]);

  return (
    <li className={`nav-item${isMenuExtended ? ' menu-open' : ''}`}>
      <a
        className={`nav-link${
          isMainActive || isOneOfChildrenActive ? ' active' : ''
        }`}
        role="link"
        onClick={handleMainMenuAction}
        style={{cursor: 'pointer'}}
      >
        <MenuIcon itemName={menuItem.name} />

        {/* {
          <>
            <i className="nav-icon fas fa-tachometer-alt" />
            <p>{t<string>(menuItem.name)}</p>
          </>
        } */}
        {isExpandable ? <i className="right fas fa-angle-left" /> : null}
      </a>

      {isExpandable &&
        menuItem &&
        menuItem.children &&
        menuItem.children.map((item) => (
          <ul key={item.name} className="nav nav-treeview">
            <li className="nav-item">
              <NavLink className="nav-link" to={`${item.path}`}>
                <i className="far fa-circle nav-icon" />
                <p>{t<string>(item.name)}</p>
              </NavLink>
            </li>
          </ul>
        ))}
    </li>
  );
};

export default MenuItem;
